import React from 'react';

const Tw = () => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.643 0H2.357C1.056 0 0 1.104 0 2.464v18.072C0 21.896 1.056 23 2.357 23h17.286C20.944 23 22 21.896 22 20.536V2.464C22 1.104 20.944 0 19.643 0zM17.24 8.153c.01.143.01.292.01.436 0 4.451-3.24 9.58-9.163 9.58a8.835 8.835 0 0 1-4.945-1.51c.26.031.51.042.776.042a6.282 6.282 0 0 0 3.997-1.438c-1.414-.03-2.603-1-3.01-2.336.496.077.943.077 1.453-.061-1.473-.313-2.578-1.669-2.578-3.307v-.04c.427.25.928.405 1.454.425A3.312 3.312 0 0 1 4.18 8.731a3.482 3.482 0 0 1-.38-1.59c0-.626.157-1.201.437-1.699 1.586 2.043 3.968 3.378 6.64 3.522-.457-2.285 1.178-4.138 3.142-4.138.928 0 1.763.405 2.352 1.063a6.147 6.147 0 0 0 2.043-.812 3.335 3.335 0 0 1-1.414 1.854 6.19 6.19 0 0 0 1.856-.524 6.955 6.955 0 0 1-1.616 1.746z"
      fill="currentColor"
    />
  </svg>
);

export default Tw;
